import React from "react";
import { AdapterButton } from "../../../../components/Adopter";
import { AdapterLink } from "../../../../components/Adopter";
import Link from "@material-ui/core/Link";
import AppBar from "@material-ui/core/AppBar";
import Hidden from "@material-ui/core/Hidden";
import { Theme } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Container from "@material-ui/core/Container";
import { Routes } from "../../../../constants/routes";
import { ReactComponent as Logo } from "../../../../assets/svg/white_logo.svg";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { darken } from "@material-ui/core/styles/colorManipulator";
import clsx from "clsx";
import { useRouteMatch } from "react-router-dom";
import Show from "../../../../components/Show";

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    boxShadow: "none",
    [theme.breakpoints.up("md")]: {
      backgroundColor: "transparent",
    },
    [theme.breakpoints.down("md")]: {
      padding: 0,
    },
  },
  roundedCorners: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      backgroundColor: theme.palette.background.paper,
      width: "100%",
      height: 22,
      marginBottom: -2,
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
    },
  },
  toolbar: {
    padding: "0 15px",
  },
  logo: {
    flexGrow: 1,
    width: "100%",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  logoImage: {
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    width: 144,
  },
  signIn: {
    marginRight: 30,

    "&:hover": {
      textDecoration: "none",
    },
  },
  link: {
    fontWeight: 600,
    textDecoration: "none",
    color: "#e6c224",
    transition: theme.transitions.create(["color", "textDecoration"]),
    "&:hover": {
      color: darken("#e6c224", 0.3),
    },
  },
}));

const PublicHeader = () => {
  const classes = useStyles();

  const { path } = useRouteMatch();

  return (
    <AppBar color="primary" position="relative" className={classes.header}>
      <Container disableGutters>
        <Toolbar className={classes.toolbar}>
          <div className={classes.logo}>
            <Link href="/">
              <Logo className={classes.logoImage} />
            </Link>
            <Hidden smDown>
              <div>
                <Show
                  condition={
                    path.includes(Routes.REGISTER) ||
                    path.includes(Routes.SERVICES)
                  }
                >
                  <AdapterLink
                    to={`/${Routes.LOGIN}`}
                    className={clsx(classes.link, classes.signIn)}
                  >
                    Sign In
                  </AdapterLink>
                </Show>

                <Show
                  condition={
                    path.includes(Routes.LOGIN) ||
                    path.includes(Routes.SERVICES)
                  }
                >
                  <AdapterButton to={`/${Routes.REGISTER}`}>
                    Sign Up
                  </AdapterButton>
                </Show>
              </div>
            </Hidden>
          </div>
        </Toolbar>
      </Container>
      <div className={classes.roundedCorners} />
    </AppBar>
  );
};

export default React.memo(PublicHeader);
